<template>
    <div class="float-left">
        <b-modal
        size="lg"
        v-model="mostrarModal"
        no-close-on-backdrop
        @close="fecharModal()"
        @show="preencher()">
            <div slot="modal-title">
                Prestação de Contas Final -
                <b-badge variant="warning">{{ operacao }}</b-badge>
            </div>
                <app-erros-box :erros="erros" v-if="erros.length > 0"></app-erros-box>
            <b-row>
                <b-col sm="10" md="5">
                    <b-form-group>
                        <label for="codTipoPrestacaoContas" class="required">Tipo da Prestação</label>
                        <b-input-group>
                            <b-form-select
                                type="text"
                                :options="tiposPrestacoes"
                                value-field="key"
                                text-field="label"
                                v-model="codTipoPrestacaoContas">
                            </b-form-select>
                            <b-form-invalid-feedback>O Tipo da Prestação é obrigatório</b-form-invalid-feedback>
                        </b-input-group>
                    </b-form-group>
                </b-col>
                <b-col sm="12" md="6">
                    <div>
                        <label>Simples Nacional</label>
                        <b-form-checkbox v-model="simplesNacional" name="check-button" @change="simplesNacionalClicado()">
                        </b-form-checkbox>
                    </div>
                </b-col>
            </b-row>
            <template>
            </template>
            <b-row>
                <b-col sm="12" md="6">
                    <b-form-group>
                        <label for="Acao" class="required">Ações</label>
                        <b-input-group>
                            <b-form-select
                                type="text"
                                :options="acoes"
                                text-field="descricao"
                                value-field="idAcaoConvenio"
                                v-model="idAcaoConvenio">
                            </b-form-select>
                            <b-form-invalid-feedback>A Ação é obrigatória</b-form-invalid-feedback>
                        </b-input-group>
                    </b-form-group>
                </b-col>
                <b-col sm="12" md="6">
                    <b-form-group>
                        <label for="NaturezaDespesa" class="required">Natureza da Despesa</label>
                        <b-input-group>
                            <b-form-select
                                type="text"
                                :options="naturezas"
                                text-field="descricaoCompleta"
                                value-field="idNaturezaDespesa"
                                v-model="idNaturezaDespesa">
                            </b-form-select>
                            <b-form-invalid-feedback>A Natureza é obrigatória</b-form-invalid-feedback>
                        </b-input-group>
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row>
                <b-col sm="12" md="3">
                    <b-form-group>
                        <label for="vcDocumento" class="required">Nº Documento</label>
                        <b-input-group>
                            <b-form-input
                                type="text"
                                v-model="vcDocumento">
                            </b-form-input>
                            <b-form-invalid-feedback>Documento é obrigatório</b-form-invalid-feedback>
                        </b-input-group>
                    </b-form-group>
                </b-col>
                <b-col sm="12" md="9">
                    <b-form-group>
                        <label for="vcFavorecido" class="required">Favorecido</label>
                        <b-input-group>
                            <b-form-input
                                type="text"
                                v-model="vcFavorecido">
                            </b-form-input>
                            <b-form-invalid-feedback>Favorecido é obrigatório</b-form-invalid-feedback>
                        </b-input-group>
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row>
                <b-col sm="12" md="3">
                    <b-form-group>
                        <label class="required">Nº do Lançamento bancário</label>
                        <b-input-group>
                            <b-form-input
                                type="text"
                                v-model="lancamentoBancario">
                            </b-form-input>
                            <b-form-invalid-feedback>O nº do lançamento é obrigatório</b-form-invalid-feedback>
                        </b-input-group>
                    </b-form-group>
                </b-col>
                <b-col sm="12" md="3">
                    <b-form-group>
                        <label for="dtEmissao" class="required">Data Emissão</label>
                        <b-input-group>
                            <date-picker
                                v-model="dtEmissao"
                                :config="$datePickerOptions"
                                @input.native="$v.convenio.dtInicioVigencia.$touch()"
                                v-mask="'##/##/####'">
                            </date-picker>
                            <b-form-invalid-feedback>Data Emissão é obrigatória</b-form-invalid-feedback>
                        </b-input-group>
                    </b-form-group>
                </b-col>

                <b-col sm="12" md="3">
                    <b-form-group>
                        <label for="dtPagamento">Data Pagamento</label>
                        <b-input-group>
                            <date-picker
                                v-model="dtPagamento"
                                @input.native="$v.convenio.dtInicioVigencia.$touch()"
                                :config="$datePickerOptions"
                                v-mask="'##/##/####'">
                            </date-picker>
                        </b-input-group>
                    </b-form-group>
                </b-col>
                <b-col sm="12" md="3">
                    <b-form-group>
                        <label>Valor</label>
                        <b-input-group>
                            <money
                                v-model="nuValor"
                                v-bind="money"
                                class="form-control text-right">
                            </money>
                        </b-input-group>
                    </b-form-group>
                </b-col>
            </b-row>

            <b-row>
                <b-col sm="12" md="4">
                    <b-form-group>
                        <label>Cofins</label>
                        <b-input-group>
                            <money
                                v-model="nuConfins"
                                v-bind="money"
                                class="form-control text-right">
                            </money>
                        </b-input-group>
                    </b-form-group>
                </b-col>
                <b-col sm="12" md="4">
                    <b-form-group>
                        <label>CSLL</label>
                        <b-input-group>
                            <money
                                v-model="nuCsll"
                                v-bind="money"
                                class="form-control text-right">
                            </money>
                        </b-input-group>
                    </b-form-group>
                </b-col>
                <b-col sm="12" md="4">
                    <b-form-group>
                        <label>INSS</label>
                        <b-input-group>
                            <money
                                v-model="nuInss"
                                v-bind="money"
                                class="form-control text-right">
                            </money>
                        </b-input-group>
                    </b-form-group>
                </b-col>
            </b-row>

            <b-row>
                <b-col sm="12" md="4">
                    <b-form-group>
                        <label>IR</label>
                        <b-input-group>
                            <money
                                v-model="nuIr"
                                v-bind="money"
                                class="form-control text-right">
                            </money>
                        </b-input-group>
                    </b-form-group>
                </b-col>
                <b-col sm="12" md="4">
                    <b-form-group>
                        <label>ISS</label>
                        <b-input-group>
                            <money
                                v-model="nuIss"
                                v-bind="money"
                                class="form-control text-right">
                            </money>
                        </b-input-group>
                    </b-form-group>
                </b-col>
                <b-col sm="12" md="4">
                    <b-form-group>
                        <label>PIS</label>
                        <b-input-group>
                            <money
                                v-model="nuPis"
                                v-bind="money"
                                class="form-control text-right">
                            </money>
                        </b-input-group>
                    </b-form-group>
                </b-col>
            </b-row>
            <div slot="modal-footer">
                <b-button 
                variant="secondary" 
                @click.stop="fecharModal()"
                >Cancelar</b-button>
                <b-button
                variant="primary"
                :disabled="this.$v.$invalid"
                @click.stop="salvar()"
                class="ml-1"
                >Salvar</b-button>
            </div>
        </b-modal>
    </div>
</template>

<script>
import { required } from 'vuelidate/lib/validators'
import ConveniosServicos from '../../ConveniosServicos'

export default {

    props: {
        operacaoProp: String,
        mostrarModal: {
            type: Boolean, 
            default: () => false
        },
        erros: {
            type: Array,
            default: () => []
        },
        convenio: {
            type: Object,
        },
        prestacaoContasFinalLancamento: Object,
        desativarBotao: Boolean,
        inseridoAtualizado: Boolean,
    },

    validations: {
        prestacaoContasFinalLancamento: {
            idAcaoConvenio: { required },
            idNaturezaDespesa: { required },
            codTipoPrestacaoContas: { required },
        },
        vcDocumento : { required },
        vcFavorecido: { required },
        dtEmissao: { required },
        lancamentoBancario: { required }
    },

    data() {
        return {
            valor: 0,
            money: {
                decimal: ',',
                thousands: '.',
                prefix: 'R$ ',
                suffix: '',
                precision: 2,
                masked: false
            },
            naturezas: [],
            acoes: [],
            codSituacao: 0,
            codTipoPrestacaoContas: 0,
            idAcaoConvenio: 0,
            idNaturezaDespesa: 0,
            dtEmissao: null,
            dtPagamento: null,
            idPrestacaoContasFinal: 0,
            idPrestacaoContasMensal: 0,
            nuConfins: 0,
            nuCsll: 0,
            nuInss: 0,
            nuIr: 0,
            nuIss: 0,
            nuPis: 0,
            nuValor: 0,
            situacao: null,
            tipoPrestacaoContas: null,
            vcDoctoPag: null,
            vcDocumento: null,
            vcFavorecido: null,
            vcObservacao: null,
            simplesNacional: true,
            impostos: null,
            simplesClicado: false,
            lancamentoBancario: null,
            tiposPrestacoes: [
                {
                    key: '1',
                    label: 'RECURSOS SEBRAE'
                },
                {
                    key: '2',
                    label: 'CONTRAPARTIDA FINANCEIRA'
                },
                {
                    key: '3',
                    label: 'CONTRAPARTIDA ECONÔMICA'
                }
            ],
        }
    },

    methods: {
        preencher() {
            if (this.operacaoProp == 'A') {
                this.simplesNacional = this.prestacaoContasFinalLancamento.simplesNacional
                this.nuValor = this.prestacaoContasFinalLancamento.nuValor
                this.obterAcoes()
                this.codTipoPrestacaoContas = this.prestacaoContasFinalLancamento.codTipoPrestacaoContas
                this.dtEmissao = this.$moment(this.prestacaoContasFinalLancamento.dtEmissao).format('DD/MM/YYYY')
                this.dtPagamento = this.prestacaoContasFinalLancamento.dtPagamento != null ? this.$moment(this.prestacaoContasFinalLancamento.dtPagamento).format('DD/MM/YYYY') : null,
                this.idAcaoConvenio = this.prestacaoContasFinalLancamento.idAcaoConvenio
                this.obterNaturezas()
                this.idNaturezaDespesa = this.prestacaoContasFinalLancamento.idNaturezaDespesa
                this.idPrestacaoContasFinal = this.prestacaoContasFinalLancamento.idPrestacaoContasFinal
                this.idPrestacaoContasMensal = this.prestacaoContasFinalLancamento.idPrestacaoContasMensal
                this.situacao = this.prestacaoContasFinalLancamento.situacao
                this.tipoPrestacaoContas = this.prestacaoContasFinalLancamento.tipoPrestacaoContas
                this.vcDoctoPag = this.prestacaoContasFinalLancamento.vcDoctoPag
                this.vcDocumento = this.prestacaoContasFinalLancamento.vcDocumento
                this.vcFavorecido = this.prestacaoContasFinalLancamento.vcFavorecido
                this.vcObservacao = this.prestacaoContasFinalLancamento.vcObservacao
                this.codSituacao = this.prestacaoContasFinalLancamento.codSituacao
                this.nuConfins = this.prestacaoContasFinalLancamento.nuConfins
                this.nuCsll = this.prestacaoContasFinalLancamento.nuCsll
                this.nuInss = this.prestacaoContasFinalLancamento.nuInss
                this.nuIr = this.prestacaoContasFinalLancamento.nuIr
                this.nuIss = this.prestacaoContasFinalLancamento.nuIss
                this.nuPis = this.prestacaoContasFinalLancamento.nuPis
                this.simplesClicado = false
                this.lancamentoBancario = this.prestacaoContasFinalLancamento.lancamentoBancario
            } else {
                this.obterAcoes()
                this.obterNaturezas()
            }
        },

        simplesNacionalClicado(){
            this.simplesClicado = true;
        },  

        reset() {
            this.codTipoPrestacaoContas= 0,
            this.idAcaoConvenio= 0,
            this.idNaturezaDespesa= 0,
            this.dtEmissao= null,
            this.dtPagamento= null,
            this.idPrestacaoContasFinal= 0,
            this.idPrestacaoContasMensal= 0,
            this.nuConfins = 0,
            this.nuCsll= 0,
            this.nuInss= 0,
            this.nuIr= 0,
            this.nuIss= 0,
            this.nuPis= 0,
            this.nuValor= 0,
            this.situacao= null,
            this.tipoPrestacaoContas= null,
            this.vcDoctoPag= null,
            this.vcDocumento= null,
            this.vcFavorecido= null,
            this.vcObservacao= null,
            this.simplesClicado = false,
            this.simplesNacional = true,
            this.lancamentoBancario = null
            this.erros = [];
            this.inseridoAtualizado = false;
        },

        obterAcoes() {
            this.$store.dispatch('addRequest')
            ConveniosServicos.obterAcoesConvenio(this.convenio.idConvenio).then(
                response => {
                if (response) {
                    if (response.success) {
                        this.acoes = response.data
                    } else {
                        this.erros = response.errors
                    }
                }
                this.$store.dispatch('removeRequest')
            })
        },

        obterNaturezas() {
            this.$store.dispatch('addRequest')
            ConveniosServicos.obterNaturezasPorAcao(this.convenio.idConvenio, this.idAcaoConvenio).then(
                response => {
                if (response) {
                    if (response.success) {
                        this.naturezas = response.data
                    } else {
                        this.erros = response.errors
                    }
                }
                this.$store.dispatch('removeRequest')
            }
            )
        },

        obterImpostos() {
            this.$store.dispatch('addRequest')
            ConveniosServicos.obterImpostos().then(
                response => {
                if (response) {
                    if (response.success) {
                        this.impostos = response.data
                        this.tributar(this.impostos)
                    } else {
                        this.erros = response.errors
                    }
                }
                this.$store.dispatch('removeRequest')
            })
        },

        tributar(impostos){
            this.nuConfins = this.nuValor * impostos.cofins
            this.nuCsll = this.nuValor * impostos.csll
            this.nuInss = this.nuValor * impostos.inss
            this.nuIr = this.nuValor * impostos.ir
            this.nuIss = this.nuValor * impostos.iss
            this.nuPis = this.nuValor * impostos.pis
        }, 

        zerarTributos(){
            this.nuConfins = 0
            this.nuCsll = 0
            this.nuInss = 0
            this.nuIr = 0
            this.nuIss = 0
            this.nuPis = 0
        },

        fecharModal() {
            this.$emit('fechar')
            this.reset()
        },

        salvar() {
            this.prestacaoContasFinalLancamento.simplesNacional = this.simplesNacional;
            this.prestacaoContasFinalLancamento.nuValor = this.nuValor;
            this.prestacaoContasFinalLancamento.nuConfins = this.nuConfins;
            this.prestacaoContasFinalLancamento.nuCsll = this.nuCsll;
            this.prestacaoContasFinalLancamento.nuInss = this.nuInss;
            this.prestacaoContasFinalLancamento.nuIr = this.nuIr;
            this.prestacaoContasFinalLancamento.nuIss = this.nuIss;
            this.prestacaoContasFinalLancamento.nuPis = this.nuPis;
            this.prestacaoContasFinalLancamento.dtEmissao = this.dtEmissao;
            this.prestacaoContasFinalLancamento.dtPagamento = this.dtPagamento;
            this.prestacaoContasFinalLancamento.idPrestacaoContasFinal = this.idPrestacaoContasFinal;
            this.prestacaoContasFinalLancamento.idPrestacaoContasMensal = this.idPrestacaoContasMensal;
            this.prestacaoContasFinalLancamento.situacao = this.situacao;
            this.prestacaoContasFinalLancamento.tipoPrestacaoContas = this.tipoPrestacaoContas;
            this.prestacaoContasFinalLancamento.vcDoctoPag = this.vcDoctoPag;
            this.prestacaoContasFinalLancamento.vcDocumento = this.vcDocumento;
            this.prestacaoContasFinalLancamento.vcFavorecido = this.vcFavorecido;
            this.prestacaoContasFinalLancamento.vcObservacao = this.vcObservacao;
            this.prestacaoContasFinalLancamento.codTipoPrestacaoContas = this.codTipoPrestacaoContas;
            this.prestacaoContasFinalLancamento.idAcaoConvenio = this.idAcaoConvenio;
            this.prestacaoContasFinalLancamento.idNaturezaDespesa = this.idNaturezaDespesa;
            this.prestacaoContasFinalLancamento.codSituacao = this.codSituacao;
            this.prestacaoContasFinalLancamento.lancamentoBancario = this.lancamentoBancario;
            this.$emit('salvar', this.prestacaoContasFinalLancamento)
            this.$emit('atualizarLista')
            this.fecharModal();
        }
    },

    computed: {
        operacao(){
            if(this.operacaoProp == 'I') {
                return 'INCLUSÃO'
            }
            return 'ATUALIZAÇÃO'
        }
    },

    watch: {
        idAcaoConvenio() {
            this.obterNaturezas()
        },

        nuValor(){
            if(this.simplesNacional == false && this.simplesClicado == true){
                this.tributar(this.impostos);
            } 
        },

        simplesNacional(){
            if(this.simplesNacional == false && this.simplesClicado == true){
                this.obterImpostos();
            } else if (this.simplesNacional == true && this.simplesClicado == true){
                this.zerarTributos();
            }
        },

        inseridoAtualizado() {
            this.fecharModal();
            this.reset()
        },
    },
}
</script>